import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaCalendar } from 'react-icons/fa';
import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import messages from '../registrationMessages';

const DurationDaysInfoPart = ({ duration, userId, date, isAfternoon, resourceType, intl }) => {
  const [info, setInfo] = useState([]);
  useEffect(() => {
    let requestToken = null;
    const timeoutHandler = setTimeout(() => {
      requestToken = Axios.CancelToken.source();
      api.base
        .post(
          `${config.appUrls.api}/api/Registration/CalcDurationInDays`,
          { userId, date, durationDays: duration, isAfternoon, resourceType },
          {
            cancelToken: requestToken.token,
          },
        )
        .then(({ data }) => {
          setInfo(data);
        })
        .catch(error => {
          if (!Axios.isCancel(error)) {
            handleHttpError(intl)(error);
          }
        });
    }, 500);
    return () => {
      clearTimeout(timeoutHandler);
      if (requestToken) requestToken.cancel('Operation canceled due to new request.');
    };
  }, [duration, userId, date, isAfternoon, resourceType, intl]);
  const lastInfo = info.slice(-1).pop();
  return (
    <div className="form-control-static">
      <FormattedMessage {...messages.Until} />
      &nbsp;
      {lastInfo && lastInfo.date && (
        <FormattedDate
          value={lastInfo.date}
          weekday="short"
          day="2-digit"
          month="2-digit"
          year="numeric"
        />
      )}
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="right"
        rootClose
        overlay={
          <Tooltip id="durationDaysFieldInfoTooltip">
            <table>
              <tbody>
                {info.map((x, i) => {
                  if (i === 20 && info.length > 25)
                    return (
                      <tr key="dot">
                        <td colSpan="2">...</td>
                      </tr>
                    );
                  if (i > 20 && i < info.length - 5) return null;
                  return (
                    <tr key={x.date}>
                      <td className="text-right text-nowrap">
                        {intl.formatDate(x.date, {
                          weekday: 'short',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                        &nbsp;&nbsp;&nbsp;
                      </td>
                      <td className="text-right text-nowrap">{x.durationMinutes.minuteToTime()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Tooltip>
        }
      >
        <span className="clickable">
          <FaCalendar className="react-icon" />
        </span>
      </OverlayTrigger>
    </div>
  );
};
DurationDaysInfoPart.propTypes = {
  duration: PropTypes.number,
  isAfternoon: PropTypes.bool,
  resourceType: PropTypes.number,
  intl: intlShape.isRequired,
};
DurationDaysInfoPart.defaultProps = {
  duration: 0,
  isAfternoon: false,
  resourceType: null,
};
export default DurationDaysInfoPart;
